import cn from 'classnames';
import React from 'react';
import styles from './privacyPolicy.module.scss';

const Section = ({ children }: { children: React.ReactNode }) => <section>{children}</section>;
Section.Title = function SectionTitle({ children }: { children: React.ReactNode }) {
  return <div className="section-title">{children}</div>;
};
Section.Paragraph = function SectionParagraph({ children }: { children: React.ReactNode }) {
  return <p className="paragraph">{children}</p>;
};
const Highlight = ({ children }: { children: React.ReactNode }) => (
  <span className="font-bold">{children}</span>
);

export const Privacy = () => {
  return (
    <>
      <main className={cn('container text-left', styles.container)}>
        <h1 className="main-title">Privacy Policy</h1>
        <Section>
          <Section.Paragraph>
            We, Secure Trade Club take the protection of your personal data very seriously. We treat
            your personal data confidentially and in accordance with the statutory data protection
            regulations at all times. In particular we pride ourselves to be in compliance with the
            General Data Protection Regulation (GDPR) and the California Consumer Privacy Act (CCPA)
            and this Privacy Policy.
          </Section.Paragraph>
          <Section.Paragraph>
            When you use this website, various personal data are collected. Personal data is data by
            which you can be personally identified.This privacy policy provides a simple overview of
            what happens to your personal data when you visit this website or services and explains
            what information we collect and how we use it and for what purpose this is done.
            However, we would like to point out that data transmission on the Internet can have
            security gaps. Thus, the complete protection of data against access by third parties is
            not possible.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Our Principles:</Section.Title>
          <Section.Paragraph>
            Secure Trade Club respects your right to privacy and is committed to the following key
            principles:
          </Section.Paragraph>
          <ul>
            <li>
              We protect your privacy and aim to provide you with a service that is tailored to your
              needs. Personal data is collected for specific purposes based on your consent or a
              legitimate interest when you contact us.
            </li>
            <li>
              You have the right to information and access to your personal data at any time and may
              request its correction or deletion.
            </li>
            <li>
              We do not sell your personal data to third parties. However, if necessary and if
              explicitly mentioned afterwards or if you have consented, we may share your data with
              group companies, brand licensees, partners and other service providers. In this case,
              their own privacy policies may also apply.
            </li>
            <li>
              We take all reasonable measures to ensure the security and protection of your data
              from misuse.
            </li>
          </ul>
          <Section.Paragraph>
            We are pleased that you are visiting and using our website, online store, and social
            media presences. We hope that during your visit you will learn more interesting facts
            about Secure Trade Club, the history of our brands and our products and services.
          </Section.Paragraph>
          <Section.Paragraph>
            This Privacy Policy explains how and for what purposes we use information collected
            about you through our website.
          </Section.Paragraph>
          <Section.Paragraph>
            Secure Trade Club respects your right to privacy when you use our website or when you
            contact us. By using our website or providing us with personal information, you accept
            the practices described in this Privacy Policy. If you do not agree with this privacy
            policy, we recommend that you do not use or visit our website or provide any personal
            data.
          </Section.Paragraph>
          <Section.Paragraph>
            Secure Trade Club reserves the right to change this privacy policy at any time. You
            should therefore check it regularly for changes. Changes will become effective upon
            their posting on this website, and we will notify you appropriately of any material
            changes.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Who is responsible for data collection on this website?</Section.Title>
          <Section.Paragraph>
            Data processing on this website is carried out by Secure Trade Club a company
            incorporated in Florida with seat in Volusia County.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>What do we use your data for?</Section.Title>
          <Section.Paragraph>
            Your data is primarily used to provide you with our services and the associated trade,
            sell and exchange functions. Further data is collected to ensure that the website is
            provided without errors. Data is also used to analyze your user behavior. In addition,
            we use your data to be able to contact you.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Why do we collect and use personal data?</Section.Title>
          <Section.Paragraph>
            Secure Trade Club collects and uses personal data for a number of different purposes.
            You may object to any of these data processing operations at any time. Your data is
            collected for the following purposes:
          </Section.Paragraph>
          <ul>
            <li>
              to allow you to create and access your user account. In these cases, we process your
              data to fulfill a contract or request.
            </li>
            <li>to engage consumers and provide you with customized service,</li>
            <li>
              to send you information, that you have requested. In these cases, we process the data
              with your consent.
            </li>
            <li>
              to involve you more actively in our services, for example by publishing your content.
              In these cases, we process the data with your consent.
            </li>
            <li>
              to contact you regarding your questions, complaints or comments by email, letter or
              telephone. In these cases, we process your personal data, including any special
              categories of personal data that you have provided with your prior consent, to process
              your specific request.
            </li>
            <li>
              to contact you for marketing purposes, including direct marketing and social functions
              within social networks. In the following cases, you give your consent to the
              processing of this data:
            </li>
            <li>to send you our newsletters, if you have subscribed to such a service.</li>
            <li>to suggest products or services that we believe may be of interest to you.</li>
            <li>
              to contact you via the mobile messaging service if you have subscribed to such a
              service. If this is done through a partner, we will also provide you with their name.
            </li>
            <li>
              to improve our website and/or combine them with third party information to understand
              your needs and provide you with better service, including customizing website and
              products for you and providing interest-based advertising. In the following cases, we
              have a legitimate interest in processing, unless otherwise stated:
            </li>
            <li>
              to evaluate the use of our website using data such as information about account
              log-in,computer usage and/or previous website usage.
            </li>
            <li>
              to evaluate the use of our website with tracking tools used on the basis of the user's
              consent or on the basis of our legitimate interest.
            </li>
            <li>
              to improve our products and services using demographic information, consumer profiles
              and consumer feedback.
            </li>
            <li>
              to analyze the effectiveness of our advertising and promotions using cookies or
              tracking technologies with your consent or based on our legitimate interest.
            </li>
            <li>to personalize your website experience based on targeted advertising.</li>
            <li>
              to maintain the daily operation, maintenance and security of the Secure Trade Club
              website.
            </li>
            <li>to conduct demographic studies or audits.</li>
            <li>to contact you for consumer research.</li>
            <li>to manage risks, disputes and records.</li>
            <li>to comply with our legal and regulatory obligations.</li>
          </ul>
        </Section>
        <Section>
          <Section.Title>Storage period</Section.Title>
          <Section.Paragraph>
            Unless a more specific retention period is stated within this privacy policy, your
            personal data will remain with us until the purpose for processing the data no longer
            applies. If you assert a justified request for deletion or revoke your consent to data
            processing, your data will be deleted unless we have other legally permissible reasons
            for storing your personal data (e.g. retention periods under tax or commercial law); in
            the latter case, the data will be deleted once these reasons no longer apply.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Revocation of your consent to data processing</Section.Title>
          <Section.Paragraph>
            Many data processing operations are only possible with your express consent. You can
            revoke consent you have already given at any time. The legality of the data processing
            carried out until the revocation remains unaffected by the revocation.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Automated decision-making</Section.Title>
          <Section.Paragraph>
            We do not use automated decision-making or profiling.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Do Not Sell My Personal Information</Section.Title>
          <Section.Paragraph>
            We do not sell information that directly identifies you, like your name, address or
            phone records.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Accuracy</Section.Title>
          <Section.Paragraph>
            It is important that the data we hold about you is accurate and current, therefore
            please keep us informed of any changes to your personal data.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>External Links</Section.Title>
          <Section.Paragraph>
            Our website contains links to the online offers of other providers. We hereby point out
            that we have no influence on the content of the linked online offers and the compliance
            with data protection regulations by their providers.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Personal data of children</Section.Title>
          <Section.Paragraph>
            Most of our website are designed and intended for adults. If a website provides content
            for a younger audience, we will obtain consent from a parent or guardian prior to
            collecting personal information if we deem it appropriate or if required by applicable
            law (the age of consent varies by country). If children's personal information has been
            provided to us, it will be deleted from our database. The child's parents (or guardians)
            may contact us to request deletion of the data or opt-out (see below for contact
            information). For this purpose, we may request a copy of an identification document
            confirming the parental or educational relationship.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>SSL or TLS encryption</Section.Title>
          <Section.Paragraph>
            Secure Trade Club uses SSL or TLS encryption for security reasons and to protect the
            transmission of confidential content, such as orders or inquiries that you send to us as
            the site operator. You can recognize an encrypted connection by the fact that the
            address line of the browser changes from "http://" to "https://" and by the lock symbol
            in your browser line. If SSL or TLS encryption is activated, the data you transmit to us
            cannot be read by third parties.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Encrypted payment transactions on this website</Section.Title>
          <Section.Paragraph>
            If there is an obligation to transmit your payment data authorization) to us after the
            conclusion of a contract subject to a charge (top-up credit), this data is required for
            payment processing. Payment transactions via the common means of payment are made
            exclusively via an encrypted SSL or TLS connection. You can recognize an encrypted
            connection by the fact that the address line of the browser changes from "http://" to
            "https://" and by the lock symbol in your browser line.With encrypted communication, the
            payment data you transmit to us cannot be read by third parties.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>What rights do you have?</Section.Title>
          <ul>
            <li>
              <div>
                <Highlight>GDPR Rights</Highlight>
              </div>
              <p>
                With regard to the data processing described in more detail below, users and data
                subjects have the right to
              </p>
              <ul>
                <li>to confirmation as to whether data relating to them is being processed, </li>
                <li>
                  to information about the data processed, to further information about the data
                  processing and to copies of the data;
                </li>
                <li>to correction or completion of incorrect or incomplete data;</li>
                <li>to immediate erasure of the data concerning them;</li>
                <li>
                  to receive the data concerning them and provided by them and to transfer this data
                  to other providers/controllers;
                </li>
                <li>
                  to lodge a complaint with the supervisory authority if they are of the opinion
                  that the data concerning them is being processed by the provider in breach of data
                  protection provisions.
                </li>
              </ul>
              <p>
                In addition, the provider is obliged to inform all recipients to whom data has been
                disclosed by the provider of any correction or deletion of data or restriction of
                processing that takes place. However, this obligation does not apply if such
                notification is impossible or involves a disproportionate effort. Notwithstanding
                this, the user has a right to information about these recipients.
              </p>
              <p>
                Likewise,users and data subjects have the right to object to the future processing
                of data concerning them, insofar as the data is processed by the provider. In
                particular, an objection to data processing for the purpose of direct advertising is
                permissible.
              </p>
              <p>
                The above rights may be limited in some circumstances, for example, if fulfilling
                your request would reveal personal information about another person, if you ask us
                to delete information which we are required to have by law, or if we have compelling
                legitimate interests to keep it. We will let you know if that is the case and will
                then only use your information for these purposes. You may also be unable to
                continue using our services if you want us to stop processing your personal
                information.
              </p>
              <p>
                We encourage you to get in touch if you have any concerns with how we collect or use
                your personal information.
              </p>
              <p>
                The legal bases for processing are listed below and at least one of these must apply
                whenever we process personal data:
              </p>
              <ul>
                <li>
                  Consent: the individual has given clear consent to process personal data for a
                  specific purpose.
                </li>
                <li>
                  Contract: the processing is necessary for a contract or because you have asked us
                  to take specific steps before entering into a contract.
                </li>
                <li>
                  Legal obligation: the processing is necessary for us to comply with the law (not
                  including contractual obligations).
                </li>
                <li>Vital interests: the processing is necessary to protect someone’s life.</li>
                <li>
                  Public task: the processing is necessary for us to perform a task in the public
                  interest or for official functions, and the task or function has a clear basis in
                  law.
                </li>
                <li>
                  Legitimate interests: the processing is necessary for our legitimate interests or
                  the legitimate interests of a third party, unless there is a good reason to
                  protect your personal data which overrides those legitimate interests.{' '}
                </li>
              </ul>
            </li>
            <li>
              <div>
                <Highlight>California Specific Rights</Highlight>
              </div>
              <p>If you are a California resident, you have the following rights:</p>
              <ul>
                <li>
                  request, up to two times each year, access to categories and specific pieces of
                  personal information about you that we collect, use, disclose, and sell.
                </li>
                <li>
                  request that we delete personal information that we collect from you, subject to
                  applicable legal exceptions.
                </li>
                <li>“opt out” of the “sale” of your “personal information” to “third parties”</li>
              </ul>
              <p>
                In addition under California’s “Shine the Light” law, California residents who
                provide personal information (as defined in the statute) to obtain services are
                entitled to request and obtain from us, once per calendar year, information about
                the personal information we shared, if any, with other businesses for marketing
                uses. If applicable, this information would include the categories of personal
                information and the names and addresses of those businesses with which we shared
                such personal information for the immediate prior calendar year (e.g., requests made
                in the current year will receive information about the prior year).
              </p>
            </li>
          </ul>
          <Section.Paragraph>
            If you have an account with Secure Trade Club, you can use the relevant options directly
            in your account and, for example, change your opt-in/opt-out settings.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Information, deletion and correction</Section.Title>
          <Section.Paragraph>
            Within the framework of the applicable legal provisions, you have the right at any time
            to free information about your stored personal data, its origin and recipient and the
            purpose of the data processing and, if applicable, the right to correction or deletion
            of this data. For this purpose, as well as for further questions on the subject of
            personal data, you can contact us at any time.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Cookies</Section.Title>
          <Section.Paragraph>
            Our website uses so-called "cookies". Cookies are small text files and do not cause any
            damage to your terminal device. They are stored either temporarily for the duration of a
            session (session cookies) or permanently (permanent cookies) on your end device. Session
            cookies are automatically deleted at the end of your visit. Permanent cookies remain
            stored on your end device until you delete them yourself or until they are automatically
            deleted by your web browser.
          </Section.Paragraph>
          <Section.Paragraph>
            In some cases, cookies from third-party companies may also be stored on your terminal
            device when you enter our site (third-party cookies). These enable us or you to use
            certain services of the third-party company (e.g. cookies for processing payment
            services).
          </Section.Paragraph>
          <Section.Paragraph>
            Cookies have various functions. Many cookies are technically necessary, as certain
            website functions would not work without them (e.g. the shopping cart function or the
            display of videos). Other cookies are used to evaluate user behavior or to display
            advertising.
          </Section.Paragraph>
          <Section.Paragraph>
            Cookies that are necessary to carry out the electronic communication process (necessary
            cookies) or to provide certain functions that you have requested (functional cookies,
            e.g. for the shopping cart function) or to optimize the website (e.g. cookies to measure
            the web audience) are stored on the basis of our legitimate interest (Art. 6 (1) lit. f
            GDPR), unless another legal basis is specified. The website operator has a legitimate
            interest in storing cookies for the technically error-free and optimized provision of
            its services. If consent to the storage of cookies has been requested, the storage of
            the cookies in question is based exclusively on this consent (Art. 6 para. 1 lit. a
            GDPR); consent can be revoked at any time.
          </Section.Paragraph>
          <Section.Paragraph>
            You can learn more about the cookies we use in our Cookie Policy and if you want to
            learn more about cookies in general, please visit{' '}
            <a href="www.allaboucookies.org">www.allaboucookies.org</a>.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Server log files</Section.Title>
          <Section.Paragraph>
            We automatically collect and store information in so-called server log files, which your
            browser automatically transmits to us. These are:
          </Section.Paragraph>
          <ul>
            <li>browser type and browser version</li>
            <li>Operating system used</li>
            <li>referrer URL</li>
            <li>URLs called up</li>
            <li>Time of the server request</li>
            <li>IP address</li>
            <li>
              This data is not merged with other data sources. The server log files are deleted
              after seven days.
            </li>
          </ul>
          <Section.Paragraph>
            The collection of this data is based on our legitimate interest (Art. 6 (1) lit. f
            GDPR). We have a legitimate interest in the technically error-free presentation and
            optimization of his website - for this purpose, the server log files must be collected.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Contacting us</Section.Title>
          <Section.Paragraph>
            If you send us inquiries, your details, including the contact data you provide there,
            will be stored by us for the purpose of processing the inquiry and in the event of
            follow-up inquiries. We do not pass on this data without your consent.
          </Section.Paragraph>
          <Section.Paragraph>
            The processing of the transmitted data is therefore based exclusively on your consent
            (Art. 6 para. 1 lit. a GDPR). You can revoke this consent at any time. To do so, simply
            send a message to one of the contact addresses listed in the imprint. The legality of
            the data processing operations carried out until the revocation remains unaffected by
            the revocation.
          </Section.Paragraph>
          <Section.Paragraph>
            The data you have transmitted will remain with us until you request us to delete it or
            revoke your consent to store it. As soon as the purpose for storing the data ceases to
            apply (e.g. after processing your inquiry has been completed), the data is automatically
            deleted after 12 months. Mandatory legal provisions - in particular retention periods -
            remain unaffected.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Registration</Section.Title>
          <Section.Paragraph>
            Registration requires some personal information, the following information is collected:
            First Name,Last Name, User name, Email, Password. Full registration is necessary to use
            our services.You may also sign up using social log in from Facebook. Using this however,
            is subject to the relevant providers privacy obligations. Your e-mail address is
            required in particular for the following purposes: Verification of the account upon
            registration, delivery of temporary passwords (forgotten password), delivery of
            forgotten user name, notifications about deadline expirations/ credits/ recharges/
            refunds/ swap requests/ swap cancellations/ search requests, messages from members,
            Notification of changes to terms and conditions and prices, notification of important
            new features at Secure Trade Club, newsletter distribution (if consent has been given),
            contact by Secure Trade Club to resolve problems, answering support queries,
            notification of longer periods of inactivity and imminent account deletion.
          </Section.Paragraph>
          <Section.Paragraph>
            Name, title and address(es) are required for the following purposes: Creation of
            invoices, partly for the execution of payments by means of payment service providers,
            transfer of address to exchange partners for the delivery of items, partly for
            salutation in notifications from Secure Trade Club.
          </Section.Paragraph>
          <Section.Paragraph>
            The processing of the entered data is based on your consent (Art. 6 para. 1 lit. a
            GDPR). You can revoke your consent at any time. To do so, simply send a message to one
            of the contact addresses listed in the imprint. The legality of the data processing
            already carried out remains unaffected by the revocation.
          </Section.Paragraph>
          <Section.Paragraph>
            The data collected in this way will be deleted upon termination, revocation of consent
            or inactivity (not logged in for two years). Data subject to statutory retention periods
            (e.g. invoices) remain unaffected by this.
          </Section.Paragraph>
          <Section.Paragraph>
            In addition, we may retain personal data of deleted accounts to protect our legitimate
            interests pursuant to Art. 6(1)(f) GDPR if required by applicable law, for fraud
            prevention, to enforce fee claims, to support investigations, to enforce our T&Cs and to
            take other actions permitted or required by applicable national law. If it is no longer
            necessary for us to retain your personal data, we will destroy it, but no later than 10
            years.
          </Section.Paragraph>
          <Section.Paragraph>
            We store your confirmation e-mail (double opt-in procedure) for registration as proof in
            accordance with Art. 6 Para. 1 lit. f GDPR (Legitimate Interest). This proof is deleted
            two years after cancellation, revocation of consent or inactivity (not logged in for two
            years).
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Profile details</Section.Title>
          <Section.Paragraph>
            In order to present oneself to other members, optional profile information can be
            provided, including: Profile picture, about-me text, homepage link, postcode/city (make
            visible to others and findable via member search). The processing of the data provided
            is based on your consent (Art. 6 para. 1 lit. a GDPR). You can revoke your consent at
            any time. To do so, simply send a message to one of the contact addresses listed in the
            imprint. The legality of the data processing already carried out remains unaffected by
            the revocation. The profile details will be deleted upon termination, revocation of
            consent or inactivity (not logged in for two years).
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Internal messages</Section.Title>
          <Section.Paragraph>
            For communication with other members, internal messages can be sent and received via
            Secure Trade Club. In addition, Secure Trade Club can send you internal messages (e.g.
            status info or new features). We will also inform you about new messages from other
            members via the e-mail address you provided during registration.
          </Section.Paragraph>
          <Section.Paragraph>
            The processing of the data provided is based on your consent (Art. 6 para. 1 lit. a
            GDPR). You can revoke your consent at any time. To do so, simply send a message. The
            legality of the data processing already carried out remains unaffected by the
            revocation. Internal messages are automatically deleted after 3 months, but you can
            remove them from your own inbox and outbox at any time. In the event of cancellation or
            revocation of consent, internal messages will be removed from your own inbox and outbox.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Newsletter dispatch</Section.Title>
          <Section.Paragraph>
            When registering for the Secure Trade Club newsletter, your e-mail address will be used
            with your consent for advertising purposes, for example to draw your attention to bonus
            campaigns or special offers. We use the so- called double opt-in procedure for
            confirmation. This ensures that the newsletter dispatch is only activated if we have
            your express confirmation, which we log accordingly. The processing of the data is based
            on your consent in accordance with Art. 6 Para. 1 lit. a GDPR. You can revoke this
            consent at any time. To do so, simply send a message to one of the contact addresses
            listed in the imprint. Furthermore, you can unsubscribe from the newsletter yourself at
            any time in the "Personal data" section or use the unsubscribe link that you will find
            below each newsletter.
          </Section.Paragraph>
          <Section.Paragraph>
            We store your confirmation e-mail (double opt-in procedure) for newsletter receipt as
            proof in accordance with Art. 6 Para. 1 lit. f GDPR (Legitimate Interest). This proof is
            deleted two years after cancellation, revocation of consent, inactivity (not logged in
            for two years) or unsubscription from the newsletter.
          </Section.Paragraph>
          <Section.Paragraph>
            Finally, it should be noted that e-mail notifications about new functions,
            system-relevant status information (e.g. maintenance work), changes to our Terms and
            Conditions and prices do not require consent and can therefore not be canceled in
            principle.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Transmission of data to transport service providers</Section.Title>
          <Section.Paragraph>
            For the purpose of delivering ordered goods, we work together with logistics service
            providers/transport companies and/or partners. The following data may be transmitted to
            them for the purpose of delivery of the ordered goods or for their announcement: First
            name, last name, postal address, e-mail address, telephone number. The legal basis for
            the processing is Art. 6(1)(b) GDPR.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>
            Transmission of data on outstanding debts to debt collection service providers
          </Section.Title>
          <Section.Paragraph>
            If you fail to pay outstanding invoices, we may transmit the data required to carry out
            a debt collection to a debt collection service provider for the purpose of trustee
            collection. Alternatively, we can sell the outstanding receivables to a collection
            service provider. This service provider then becomes the holder of the claim and asserts
            the claims in its own name. The legal basis for the transmission of data within the
            scope of trustee collection is Art. 6 (1) (b) GDPR; the transmission of data within the
            scope of the sale of receivables is based on Art. 6 (1) (f) GDPR. Furthermore, the debt
            collection service provider may, as a service to us, transmit the information that an
            outstanding payment claim exists to credit agencies. This also applies to the
            fulfillment of a subsequent notification obligation in the event that the amount has
            changed (e.g. reduction of the claim due to a payment by you). This subsequent
            notification safeguards your legitimate interests by ensuring that the data held by the
            respective credit agency is up to date. The legal basis for updating the amount of
            claims against credit agencies is the provision in Art. 6 (1) f) GDPR.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Data processing for advertising purposes</Section.Title>
          <Section.Paragraph>
            In principle, we have a legitimate interest in using your data for marketing purposes.
            We collect the following data for our own marketing purposes as well as for the
            marketing purposes of third parties: first name, last name, postal address, year of
            birth.
          </Section.Paragraph>
          <Section.Paragraph>
            The aforementioned data may also be transmitted to third parties (advertisers) for this
            purpose. We are also entitled to store additional personal data about you for our own
            marketing purposes and for the marketing purposes of third parties, in compliance with
            the statutory provisions. The aim is to send you advertising that is geared solely to
            your actual or perceived needs and not to bother you with useless advertising.
          </Section.Paragraph>
          <Section.Paragraph>
            The stored data will not be passed on to third parties. Furthermore, the responsible
            party pseudonymizes / anonymizes personal data collected about you for the purpose of
            using the pseudonymized / anonymised data for its own marketing purposes as well as for
            marketing purposes of third parties (advertisers). The pseudonymized / anonymised data
            can also be used to advertise to you online on an individualized basis, whereby the
            control of the advertising can be carried out by a service provider / agency. The legal
            basis for the use of personal data for marketing purposes is Art. 6(1)(f) GDPR.
          </Section.Paragraph>
          <Section.Paragraph>
            You may object to the use of your personal data for the aforementioned marketing
            purposes at any time, free of charge and with effect for the future, by sending a
            notification to us. If you object, your data will be blocked for further data processing
            for advertising purposes. We would like to point out that in exceptional cases,
            advertising material may still be sent temporarily after receipt of your objection. This
            is technically due to the necessary lead time within the selection process and does not
            mean that we have not implemented your objection.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Processing of data (customer and contract data)</Section.Title>
          <Section.Paragraph>
            We collect, process and use personal data only to the extent that it is necessary for
            the establishment, content or amendment of the legal relationship (inventory data). This
            is done on the basis of Art. 6 para. 1 lit. b GDPR, which permits the processing of data
            for the fulfillment of a contract or pre-contractual measures. We collect, process and
            use personal data about the use of our Internet pages (usage data) only insofar as this
            is necessary to enable the user to use the service or to bill him for it.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Payment services</Section.Title>
          <Section.Paragraph>
            We integrate payment services from third-party companies on our website (
            <a href="https://stripe.com/us/privacy">Stripe</a>). When you make a purchase from us,
            your payment data (e.g. name, payment amount, account details, credit card number) are
            processed by the payment service provider for the purpose of processing the payment. The
            respective contractual and data protection provisions of the respective providers apply
            to these transactions. The payment service providers are used on the basis of Art. 6
            para. 1 lit. b GDPR (contract processing) and in the interest of a smooth, convenient
            and secure payment process (Art. 6 para. 1 lit. f GDPR). Insofar as your consent is
            requested for certain actions, Art. 6 para. 1 lit. a GDPR is the legal basis for data
            processing; consent can be revoked at any time in the future.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Data transfer to payment service providers</Section.Title>
          <Section.Paragraph>
            In order to fulfill the contract, we pass on your data to the company commissioned with
            the payment, insofar as this is necessary for the payment of our services. Depending on
            which payment method you select, we pass on the payment data collected for this purpose
            to the credit institution commissioned with the payment and, if applicable, to payment
            service providers commissioned by us or to the selected payment service provider. In
            some cases, the selected payment service providers also collect this data themselves. In
            this case, the privacy policy of the respective payment service provider applies.The
            legal basis for the data processing is contract.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Encrypted payment transactions</Section.Title>
          <Section.Paragraph>
            If there is an obligation to transmit your payment data to us (e.g. account number in
            the case of direct debit authorization) after the conclusion of a fee-based contract,
            this data is required for payment processing.
          </Section.Paragraph>
          <Section.Paragraph>
            Payment transactions via the common means of payment (Visa/MasterCard, direct debit) are
            made exclusively via an encrypted SSL or TLS connection. You can recognize an encrypted
            connection by the fact that the address line of the browser changes from "http://" to
            "https://" and by the lock symbol in your browser line.
          </Section.Paragraph>
          <Section.Paragraph>
            With encrypted communication, your payment data that you transmit to us cannot be read
            by third parties.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>
            Data processing for the purpose of fraud prevention and optimization of our payment
            processes
          </Section.Title>
          <Section.Paragraph>
            Where applicable, we provide our service providers with further data, which they use
            together with the data necessary for the processing of the payment as our processors for
            the purpose of fraud prevention and optimization of our payment processes (e.g.
            invoicing, processing of contested payments, accounting support). This serves to protect
            our legitimate interests in our protection against fraud or in efficient payment
            management, which outweigh our interests in the context of a balancing of interests.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Commercial and business services</Section.Title>
          <Section.Paragraph>
            We process data of our contractual and business partners, e.g. customers and interested
            parties in the context of contractual and comparable legal relationships as well as
            related measures and in the context of communication with contractual partners (or
            pre-contractual), e.g. to answer inquiries.
          </Section.Paragraph>
          <Section.Paragraph>
            We process this data to fulfill our contractual obligations, to secure our rights and
            for the purposes of the administrative tasks associated with this information as well as
            for business organization. We only disclose the data of the contractual partners to
            third parties within the scope of the applicable law to the extent that this is
            necessary for the aforementioned purposes or for the fulfillment of legal obligations or
            with the consent of the contractual partners (e.g. to participating telecommunications,
            transport and other auxiliary services as well as subcontractors, banks, tax and legal
            advisers, payment service providers or tax authorities).
          </Section.Paragraph>
          <Section.Paragraph>
            We inform the contractual partners which data is required for the aforementioned
            purposes before or in the course of data collection, e.g. in online forms, by means of
            special labeling (e.g. colors) or symbols (e.g. asterisks or similar), or in person.
          </Section.Paragraph>
          <Section.Paragraph>
            Unless otherwise specified the purposes of processing are Contractual performance and
            service, contact requests and communication, office and organizational procedures,
            administration and response to requests, visit action evaluation, interest-based and
            behavioral marketing, profiling (creating profiles of users). And, the Legal bases are
            Contractual performance and pre-contractual inquiries (Art. 6 para. 1 p. 1 lit. b.
            GDPR), Legal obligation (Art. 6 para. 1 p. 1 lit. c. GDPR), and our Legitimate interests
            (Art. 6 para. 1 p. 1 lit. f GDPR).
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Technical services</Section.Title>
          <Section.Paragraph>
            We process the data of our customers and clients in order to enable them to select,
            purchase or commission the selected services or works as well as associated activities
            and to pay for and deliver them or to execute or provide them. The required information
            is identified as such in the context of the order, purchase order or comparable contract
            conclusion and includes the information required for the provision of services and
            billing as well as contact information.
          </Section.Paragraph>
          <Section.Paragraph>
            Unless otherwise specified the purposes of processing are Contractual performance and
            service, contact requests and communication, office and organizational procedures,
            administration and response to requests, visit action evaluation, interest-based and
            behavioral marketing, profiling (creating profiles of users). And, the Legal bases are
            Contractual performance and pre-contractual inquiries (Art. 6 para. 1 p. 1 lit. b.
            GDPR), Legal obligation (Art. 6 para. 1 p. 1 lit. c. GDPR), and our Legitimate interests
            (Art. 6 para. 1 p. 1 lit. f GDPR).
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Direct marketing</Section.Title>
          <Section.Paragraph>
            The legal basis for the processing of your personal data in the context of direct
            marketing measures is either your consent or our legitimate interest in marketing and
            promoting our courses and services. The purpose of processing your personal data in the
            context of direct marketing measures is to send information, offers and, if applicable,
            to promote sales.
          </Section.Paragraph>
          <Section.Paragraph>
            Your personal data will be deleted as soon as they are no longer necessary to achieve
            the purpose for which they were collected; this is the case in particular upon receipt
            of the revocation or objection. You can revoke your consent at any time for the future
            or object to the processing of your personal data in the context of direct marketing
            measures at any time for the future.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>When you send a data subject access request</Section.Title>
          <Section.Paragraph>
            The legal basis for the processing of your personal data in the context of handling your
            data subject access request is our legal obligation and the legal basis for the
            subsequent documentation of the data subject access request is both our legitimate
            interest and our legal obligation. The purpose of processing your personal data in the
            context of processing data when you send a data subject access request is to respond to
            your request. The subsequent documentation of the data subject access request serves to
            fulfill the legally required accountability.
          </Section.Paragraph>
          <Section.Paragraph>
            Your personal data will be deleted as soon as they are no longer required to achieve the
            purpose for which they were collected. In the case of the processing of a data subject
            access request, this is three years after the end of the respective process. You have
            the possibility at any time to object to the processing of your personal data in the
            context of the processing of a data subject access request for the future. In this case,
            however, we will not be able to further process your request. The documentation of the
            legally compliant processing of the respective data subject access request is mandatory.
            Consequently, there is no possibility for you to object.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Legal defense and enforcement of our rights</Section.Title>
          <Section.Paragraph>
            The legal basis for the processing of your personal data in the context of legal defense
            and enforcement of our rights is our legitimate interest. The purpose of processing your
            personal data in the context of legal defense and enforcement of our rights is the
            defense against unjustified claims and the legal enforcement and assertion of claims and
            rights.
          </Section.Paragraph>
          <Section.Paragraph>
            Your personal data will be deleted as soon as they are no longer necessary to achieve
            the purpose for which they were collected. The processing of your personal data in the
            context of legal defense and enforcement is mandatory for legal defence and enforcement
            of our rights. Consequently, there is no possibility for you to object.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Social media plug-ins</Section.Title>
          <Section.Paragraph>
            We use social plug-ins from the social networks Facebook, Twitter and LinkedIn on our
            website in order to raise awareness of our company. The purpose and scope of the data
            collection and the further processing and use of the data by the respective provider, as
            well as your rights in this regard and setting options for protecting your privacy, can
            be found in the respective privacy policy of the provider, which we link to below. By
            logging out of the pages of social networks beforehand and deleting cookies that have
            been set, you can prevent social networks from assigning the information collected about
            you to your user account with the respective social network during your visit to
            www.securetradeclub.com. If you do not want social networks to use your data, you can
            delete the cookies. If you do not want social networks to directly assign the data
            collected via our website to your profile, you must log out of the corresponding social
            networks before visiting our website.{' '}
          </Section.Paragraph>
          <Section.Paragraph>
            You can also completely prevent the loading of the plugins with add-ons for your
            browser, e.g. with the script blocker "NoScript", which can be found at:
            http://noscript.net.
          </Section.Paragraph>
          <Section.Paragraph>
            The legal basis for this data processing is Article 6(1)(a) of the GDPR (consent).
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Social Media</Section.Title>
          <Section.Paragraph>
            The data you enter on our social media pages, such as comments, videos, pictures, likes,
            public messages, etc. are published by the social media platform and are not used or
            processed by us for any other purpose at any time. We only reserve the right to delete
            content if this should be necessary. Where applicable, we share your content on our site
            if this is a function of the social media platform and communicate with you via the
            social media platform. The legal basis is our legitimate interest. The data processing
            is carried out in the interest of our public relations and communication.
          </Section.Paragraph>
          <Section.Paragraph>
            If you wish to object to certain data processing over which we have an influence, please
            contact us. We will then examine your objection. If you send us a request on the social
            media platform, we may also refer you to other secure communication channels that
            guarantee confidentiality, depending on the response required. You always have the
            option of sending us confidential inquiries to our address stated in the imprint.
          </Section.Paragraph>
          <Section.Paragraph>
            As already stated, where the social media platform provider gives us the opportunity, we
            take care to design our social media pages to be as data protection compliant as
            possible. With regard to statistics that the provider of the social media platform makes
            available to us, we can only influence these to a limited extent and cannot switch them
            off. However, we make sure that no additional optional statistics are made available to
            us.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>
            Data processing by the operator of the social media platform
          </Section.Title>
          <Section.Paragraph>
            The operator of the social media platform uses web tracking methods. The web tracking
            can also take place regardless of whether you are logged in or registered with the
            social media platform. As already explained, we can unfortunately hardly influence the
            web tracking methods of the social media platform. We cannot, for example, switch this
            off.
          </Section.Paragraph>
          <Section.Paragraph>
            Please be aware: It cannot be ruled out that the provider of the social media platform
            uses your profile and behavioral data, for example to evaluate your habits, personal
            relationships, preferences, etc. We have no influence on this. In this respect, we have
            no influence on the processing of your data by the provider of the social media
            platform.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Content Delivery Network</Section.Title>
          <Section.Paragraph>
            Our web site uses a so-called Content Delivery Network (CDN). A CDN is a network of
            powerful servers that cache content at various locations around the world. A CDN has two
            main tasks: to deliver content in the shortest possible time and to reduce the load on
            the web host by distributing traffic. CDNs transmit two types of content: Static and
            dynamic content. Static content is delivered to all website visitors in the same form,
            such as video content from streaming services or code frameworks (e.g. Javascript,
            jQuery). Dynamic content is first adapted to the user and only created at the moment of
            the request. This includes content that takes place via web applications, email or
            online shops and is personalized. In order to use the latter, information about the
            website visitor must first be transmitted to the CDN. The legal basis for the use of a
            CDN and the transmission of your data to it is our legitimate interest. The legitimate
            interest results from our need for a technically flawless and fast presentation of our
            web site and the relief of our IT infrastructure. You can object to the processing of
            your data on the basis of our legitimate interest at any time. To do so, please use the
            contact details provided.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Security of data processing</Section.Title>
          <Section.Paragraph>
            We take appropriate technical and organizational measures in accordance with the CCPA
            and the GDPR, taking into account the state of the art, the costs of implementation and
            the nature, scope, circumstances and purposes of the processing, as well as the varying
            likelihood and severity of the risk to the rights and freedoms of natural persons, in
            order to ensure a level of protection appropriate to the risk; the measures include, in
            particular, safeguarding the confidentiality, integrity and availability of data by
            controlling physical access to the data, as well as access to, entry into, disclosure
            of, assurance of availability of, and separation of, the data relating to them. We also
            have procedures in place to ensure the exercise of data subjects' rights, deletion of
            data and response to data compromise. Furthermore, we already take the protection of
            personal data into account during the development or selection of hardware and software
            as well as procedures in accordance with the principle of data protection through
            technology design and through data protection-friendly default settings.
          </Section.Paragraph>
          <Section.Paragraph>
            Security measures include in particular the encrypted transmission of data between your
            browser and our servers or the encryption of your passwords in the database.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Disclosure and transmission of data</Section.Title>
          <Section.Paragraph>
            If, in the course of our processing, we disclose data to other persons and companies as
            highlighted above (processors or third parties), transmit it to them or otherwise grant
            them access to the data, this will only be done on the basis of a legal permission (e.g.
            if a transmission of the data to third parties, such as to payment service providers, is
            necessary for the performance of the contract pursuant to Art. 6 (1) lit. b GDPR), you
            have consented, a legal obligation provides for this or on the basis of our legitimate
            interests (e.g. when using agents, hosting providers, etc.). If we commission third
            parties with the processing of data on the basis of a so-called order processing
            agreement, this is done on the basis of Art. 28 GDPR.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Data security measures</Section.Title>
          <Section.Paragraph>
            All data transmitted by you personally, including your payment data, are transmitted
            using the generally accepted and secure standard SSL (Secure Socket Layer). SSL is a
            secure and proven standard that is also used, for example, for online banking. You can
            recognize a secure SSL connection, among other things, by the appended s at the http in
            the address bar of your browser or by the lock symbol in the upper or lower area of your
            browser.
          </Section.Paragraph>
          <Section.Paragraph>
            We also use appropriate technical and organizational security measures to protect your
            personal data stored with us against manipulation, partial or complete loss and against
            unauthorized access by third parties. Our security measures are continuously improved in
            line with technological developments by us and by the service providers commissioned by
            us.
          </Section.Paragraph>
        </Section>
        <Section>
          <Section.Title>Changes to the privacy policy</Section.Title>
          <Section.Paragraph>
            In the event of changes to the privacy policy, we will post the amended version and the
            effective date of the change on this website. We recommend that you read our privacy
            policy at regular intervals. We will only make changes that affect consent you have
            given us by obtaining your consent again.
          </Section.Paragraph>
        </Section>
      </main>
    </>
  );
};
